/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createChangeProposal} from '../api'

export const useMutationCreateChangeProposal = createReactQueryMutationHook('createChangeProposal', createChangeProposal)
